const getOriginalItem = (item) => {
  const { items, ...originalItem } = item;

  return originalItem;
};

export default getOriginalItem;
